import { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Constants } from "../common/constants";
import { useCapabilitiesContext } from "../context/CapabilitiesContext";
import { logger } from "@siemensplm/common_utils";

export const CapabilityHandler = () => {
  const { activeCapability, loadCapability } = useCapabilitiesContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const loadCapabilityAsync = async () => {
      logger.logInformation(
        "CapabilityHandler: useEffect for loading capability started"
      );
      const queryParams = new URLSearchParams(location.search);
      const capabilityName = queryParams.get(Constants.capability);
      const capabilityId = queryParams.get(Constants.capabilityId);
      const capabilityDomain = queryParams.get(Constants.capabilityDomain);
      if (capabilityName && capabilityId && capabilityDomain) {
        logger.logInformation(
          `CapabilityHandler: Loading capability - Name: ${capabilityName}, ID: ${capabilityId}, Domain: ${capabilityDomain}`
        );
        const capChange = await loadCapability(
          capabilityName,
          capabilityId,
          capabilityDomain
        );
        if (capChange) {
          const value = {
            capabilityName: capabilityName,
            capabilityId: capabilityId,
            capabilityDomain: capabilityDomain,
          };
          const capability = JSON.stringify(value);
          localStorage.setItem(Constants.activeCapability, capability);
        }
      }
    };
    loadCapabilityAsync();
  }, []);

  useEffect(() => {
    if (activeCapability) {
      const queryParams = new URLSearchParams(location.search);
      const redirectPath = queryParams.get(Constants.redirect);
      if (activeCapability && redirectPath) {
        navigate(redirectPath);
      }
    }
  }, [activeCapability]);

  return null;
};
